import React from 'react';
import * as PropTypes from 'prop-types';
import CustomMenu from '../customMenu/CustomMenu';
import Header from '../header/Header';
import Icon from '../icon/Icon';

export default function CustomHeader({ menuList, mod, copyright, children }) {
  return (
    <Header
      burger={true}
      mod={mod}
      menu={
        <CustomMenu
          {...menuList}
          copyright={copyright}
          wrapperLogo={
            <a href={'#'} target={'_blank'} className={'custom-header__logo'}>
              <Icon name={'logo'} />
            </a>
          }
        />
      }
    >
      {children}
    </Header>
  );
}

CustomHeader.propTypes = {
  menuList: PropTypes.object,
};
